import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface ClearBrokerButtonProps {
    brokerId: number | undefined;
    onClear: () => void;
    disabled: boolean;
}

/** Removes the chosen broker from the loan, so another can be picked; hidden while there's none. */
export const ClearBrokerButton = ({ brokerId, onClear, disabled }: ClearBrokerButtonProps) => {
    if (!brokerId) {
        return null;
    }

    return (
        <IconButton
            id='borrowerBrokerClear'
            theme={IconButtonTheme.DarkBlueActive}
            size={IconButtonSize.ExtraSmall}
            icon={faTimes}
            hint='Remove selected broker from this loan'
            disabled={disabled}
            handleClick={onClear}
        />
    );
};
